import React, { useState } from "react";
import { Subscriptions } from "@mui/icons-material";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import ContactModal from "../contact-modal";

function SubscriptionCard() {
  // STATES
  const [contactPreview, setcontactPreview] = useState(false);

  // CONST VALS
  const history = useHistory();

  return (
    <div className="subscription-wrapper">
      <div className="subscribe-card">
        <div className="thumb">
          <Subscriptions />
        </div>
        <p>
          This feature is only available to enterprise users. Contact us to access this
          feature or use investors search to find investors.
        </p>
        <div className="action-btns">
          <Button type="primary" onClick={() => history.push("/dataset")}>
            Go to investors search
          </Button>
          <Button type="primary" onClick={() => setcontactPreview(true)}>
            Contact us
          </Button>
        </div>
      </div>
      <ContactModal
        preview={contactPreview}
        closeHandler={() => setcontactPreview(false)}
      />
    </div>
  );
}

export default SubscriptionCard;
